<template>
  <button @click="open" class="btn btn-sm btn-info mr-1 mb-1">
    <font-awesome-icon icon="bolt"/>&nbsp;{{ $t('divideClient') }}
    <b-modal v-model="showForm" no-close-on-backdrop no-enforce-focus :title="$t('divideClient')">
      <div class="alert alert-info">
        <ul class="mb-0">
          <li>Cần khóa các tài khoản sẽ chuyển sang client mới</li>
          <li>Chi phí: từ 10 tài khoản 500.000, 10-50 tài khoản 1.000.000, trên 500 tài khoản 1,500,000 (Tạo giao dịch bằng tay)</li>
        </ul>
      </div>
      <client-select :disabled="true" :label="$t('clientToDivide')" :model="formModel" attribute="clientA" :errors="formErrors" :status="'1'"></client-select>
      <p v-if="clientALoading" class="text-center"><b-spinner></b-spinner></p>
      <template v-else-if="clientA">
        <p><span>{{$t('clientACurrentUserLimit')}}</span>: {{clientA.userLimit}}</p>
        <p><span>{{$t('clientACurrentUserCount')}}</span>: {{clientA.userCount}}</p>
        <p><span>{{$t('creditBalance')}}</span>: {{clientA.creditBalance | numFormat }}</p>
        <p><span>{{$t('clientAExpireTime')}}</span>: {{clientA.expireTime | moment('DD/MM/YYYY HH:mm:ss')}}</p>
      </template>
      <form-input :label="$t('numberOfUserToDivide')" attribute="x" :model="formModel" :errors="formErrors"></form-input>
      <p v-if="clientA && formModel.x"><span>{{$t('clientAUserLimitAfterDivide')}}</span>: {{clientA.userLimit - formModel.x}} ({{$t('note')}})</p>
      <client-select :label="$t('clientToDivideTo')" :model="formModel" attribute="clientB" :errors="formErrors" v-if="formModel.x > 0"></client-select>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button :disabled="!formModel.clientA || !formModel.clientB || !formModel.x || clientA.userLimit - formModel.x < clientA.userCount" class="btn btn-primary float-right" @click="divide()">
          {{ $t('divide') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>
<script>
  import ClientSelect from "@/components/ClientSelect";
  export default {
    props: ['clientToDivide'],
    components: {ClientSelect},
    data() {
      return {
        showForm: false,
        formModel: {
          transaction: true,
          clientA: this.clientToDivide ? this.clientToDivide : null,
          clientB: null,
          x: 0,
        },
        clientA: null,
        clientALoading: false,
        formErrors: []
      }
    },
    methods: {
      open() {
        this.formModel = {
          clientA: this.clientToDivide ? this.clientToDivide : null,
          x: 0,
          clientB: null
        };
        this.getClientA();
        this.showForm = true
      },
      divide() {
        this.$swal({
          title: this.$t('divideConfirm'),
          icon: "warning",
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
          let loader = this.$loading.show();
          this.$service({
              url: '/client/divide',
              method: 'post',
              data: this.formModel
            }).then(response => {
              this.showForm = false;
              if (response.data) {
                this.$swal({
                    title: this.$t('success'),
                    text: this.$t('divideSuccess'),
                    icon: 'success'
                });
                this.$bus.$emit('planOrder');
                this.$bus.$emit('loadClient');
              } else {
                this.$swal({
                    title: this.$t('error'),
                    text: this.$t('divideFailed'),
                    icon: 'error'
                });
              }
            }).catch(error => {
              if (error.response.data.message) {
                this.$swal({
                  text: error.response.data.message,
                  icon: 'error'
                });
                this.showForm = false;
              } else {
                this.formErrors = error.response.data;
              }
            }).finally(() => {
              loader.hide();
            });
          }
        })
      },
      getClientA() {
        if (this.formModel.clientA) {
          this.clientALoading = true;
          this.$service.get('/client/' + this.formModel.clientA).then(response => {
            if (response.data) {
              this.clientA = response.data
            } else {
              this.clientA = null
            }
          }).finally(() => {
            this.clientALoading = false;
          })
        }
      }
    },
    watch: {
      "formModel.clientA": {
        handler(val) {
          if (val) {
            this.getClientA();
          } else {
            this.clientA = null;
          }
        }
      },
    },   
    i18n: {
      messages: {
        en: {
          divideClient: 'Divide client',
          clientToDivide: 'Client to divide',
          numberOfUserToDivide: 'Number of user to divide',
          clientToDivideTo: 'Client to divide to',
          divideGuide: 'Before dividing client, users that will be moved to the new client must be deactivated',
          clientACurrentUserLimit: 'Current user limit',
          clientACurrentUserCount: 'Current user count',
          clientAExpireTime: 'Expire time',
          clientAUserLimitAfterDivide: 'User limit after dividing',
          note: 'This number must not be smaller than current user count',
          divide: 'Divide',
          divideConfirm: 'Are you sure to divide this client?',
          divideSuccess: 'Client divided successfully!',
          divideFailed: 'Fail to divide client'
        },
        vi: {
          divideClient: 'Tách client',
          clientToDivide: 'Client cần tách',
          numberOfUserToDivide: 'Số user cần tách',
          clientToDivideTo: 'Chuyển tới client',
          divideGuide: 'Trước khi thực hiện tách client, cần khóa các users sẽ chuyển sang client mới',
          clientACurrentUserLimit: 'Giới hạn số user',
          clientACurrentUserCount: 'Số user đang hoạt động',
          clientAExpireTime: 'Ngày hết hạn',
          clientAUserLimitAfterDivide: 'Giới hạn số user sau khi tách',
          note: 'Số này không được nhỏ hơn số user đang hoạt động',
          divide: 'Tách',
          divideConfirm: 'Bạn có chắc muốn thực hiện việc tách client này? Hãy kiểm tra kỹ các thông tin trước khi tiến hành!',
          divideSuccess: 'Tách client thành công!',
          divideFailed: 'Tách client thất bại'
        }
      }
    }
  }
</script>